"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterTypes = void 0;
class ParameterTypes {
}
exports.ParameterTypes = ParameterTypes;
ParameterTypes.String = '';
ParameterTypes.StringArray = [];
ParameterTypes.Boolean = false;
ParameterTypes.BooleanArray = [];
ParameterTypes.Number = 0;
ParameterTypes.NumberArray = [];
ParameterTypes.Date = new Date();
ParameterTypes.DatArray = [];
